import { FC, useState } from "react";

const UserAccountStatusString: FC<{
  statusIcon: { color: string; icon: string; label: string };
  isIconNeed?: boolean
}> = ({ statusIcon, isIconNeed }) => {
  return (
    <>
      <div className="flex gap-1 items-center">
        {!isIconNeed ? <img src={statusIcon?.icon} className="w-5 h-5" /> : ""}
        <h1 className={`text-base font-semibold ${statusIcon.color}`}>
          {statusIcon.label}
        </h1>
      </div>
    </>
  );
};
export default UserAccountStatusString;
